export enum FagUrgency {
  Normal = 'Normal',
  Urgent = 'Urgent',
  Emergency = 'Emergency',
}
